<template>
    <div>
    <pop-form v-if="show" width="580px" body-max-height="420px">
        <template v-slot:title>{{title}}</template>
        <div class="edit-box">
            <el-form ref="editData" :model="editData" label-width="75px">
                <el-form-item label="会员等级" prop="vip_id">
                    <el-select v-model="editData.vip_id" placeholder="请选择" class="select-box">
                        <el-option label="无" :value="''"></el-option>
                        <el-option v-for="(vip, key) in vip_list" :key="key" :label="vip.vip_name" :value="vip.vip_id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="有效时间">
                    <el-date-picker
                            v-model="editData.vip_expire"
                            type="date"
                            value-format="yyyy-MM-dd"
                            class="select-box"
                            placeholder="不输入为永久有效">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="续费金额" prop="join_price">
                    <el-input v-model="editData.join_price" style="width: 300px;" />&nbsp;&nbsp;
                    <!--<el-checkbox v-model="editData.is_user_money">当余额使用</el-checkbox>-->
                </el-form-item>

                <el-form-item label="服务人员">
                    <el-button type="text" @click="selectStaffState = true">添加</el-button>
                    <span class="split-icon"></span>
                    <el-button type="text" @click="clearStaff">清空</el-button>
                </el-form-item>
            </el-form>

            <div class="staff-box">
                <el-table :data="staffListData" height="170" style="width: 100%" ref="selectTable" class="table-box-2" v-show="staffListData.length > 0">
                    <el-table-column prop="work_id" label="工号" />
                    <el-table-column prop="name" label="姓名" />
                    <el-table-column label="操作">
                        <template slot-scope="data">
                            <el-button type="text" @click="deleteStaff(data.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <template v-slot:foot>
            <div class="foot-box flex flex-align-center">
                <div class="left flex-1">
                    <el-button-group>
                        <el-button size="mini" @click="giveState = true">赠送</el-button>
                        <el-button size="mini" @click="remarkState = true">备注</el-button>
                    </el-button-group>
                </div>
                <div class="right flex-1">
                    <el-button size="medium" @click="close">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>
                    <el-button size="medium" type="primary" @click="editSubmit">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
                </div>
            </div>
        </template>
    </pop-form>

        <!--提交结算-->
        <store-user-total-done v-model="totalState" :settleData="totalData" :is-extend="true" @settleOver="settleOver" />
        <!--赠送-->
        <cash-give v-model="giveState" :init-data="giveData" @submit="setGiveData" />
        <!--备注-->
        <cash-remark v-model="remarkState" :init-data="remark" @submit="setRemarkData" />
        <!--选择服务人员-->
        <CashStaffSelectBox v-model="selectStaffState" :pro-type="6" :selected-staff="staffListData" @selected="selectStaffEvent"/>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    import StoreUserTotalDone from "@/model/StoreUser/StoreUserTotalDone";
    import CashGive from "@/model/Cash/CashGive";
    import CashRemark from "@/model/Cash/CashRemark";
    import CashStaffSelectBox from "@/model/Cash/CashStaffSelectBox";
    export default {
        name: "StoreUserExtend",
        components: {CashStaffSelectBox, CashRemark, CashGive, StoreUserTotalDone, PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            userInfo: {
                type: [Object, Array],
                default: 0
            }
        },
        data: ()=> ({
            title: "会员续费",
            editData: {
                vip_id: "",
                vip_expire: "",
                join_price: "",
            },

            totalState: false,
            totalData: {},
            vip_list: [],

            giveState: false,
            remarkState: false,
            giveData: null,
            remark: "",

            selectStaffState: false,
            staffListData: []
        }),
        mounted: function () {

        },
        methods: {
            init: function () {
                this.editData = {
                    vip_id: obj.isEmpty(this.userInfo.vip_id) ? "" : this.userInfo.vip_id,
                    vip_expire: this.userInfo.vip_expire,
                    join_price: "",
                };
                this.staffListData = [];
                this.loadVipList();
            },
            close: function () {
                this.$emit("showChange", false);
            },
            editSubmit: function () {
                this.totalData = {
                    id: this.userInfo.store_uid ? this.userInfo.store_uid : this.userInfo.id,
                    vip_id: this.editData.vip_id,
                    vip_expire: this.editData.vip_expire,
                    join_price: this.editData.join_price,
                    actual_price: 0,
                    pay_type: 0,
                    give_data: JSON.stringify(this.giveData),
                    remark: this.remark,
                    staff: JSON.stringify(this.staffListData)
                };
                this.totalState = true;
            },

            settleOver: function () {
                obj.message.success("续费成功！");
                this.$emit("onOver");
                this.close();
            },

            //加载VIP列表
            loadVipList: function () {
                let storeUid = this.userInfo.store_uid ? this.userInfo.store_uid : this.userInfo.id;
                obj.postData("store_vip/get_vip_sort_list", {store_uid: storeUid}, res => {
                    if(res.errcode === 0)
                        this.vip_list = res.data;
                });
            },

            //设置赠送数据
            setGiveData: function (giveData) {
                this.giveData = giveData;
            },

            //设置备注信息
            setRemarkData: function (remark) {
                this.remark = remark;
            },

            //选择服务人员回调
            selectStaffEvent: function (staffList) {
                this.staffListData = staffList;
            },
            //删除指定服务人员
            deleteStaff: function (index) {
                this.staffListData.splice(index, 1);
            },
            //清空服务人员
            clearStaff: function () {
                this.staffListData = [];
            }
        },
        watch: {
            show: function (v) {
                if(v) this.init();
            }
        }
    }
</script>

<style scoped>
    .foot-box{
        padding: 0 24px 14px;
    }
    .foot-box .left{
        text-align: left;
    }
    .foot-box .right{
        text-align: right;
    }
    .edit-box{
        padding: 0px 14px;
    }
    .select-box{
        width: 100%;
    }
    .split-icon{
        width: 2px;
        height: 15px;
        background-color: #cccccc;
        display: inline-block;
        margin: 0px 9px -2px;
    }
    .staff-box{
        clear: both;
        min-height: 20px;
    }
</style>
